"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
var immutable_1 = require("immutable");
function currenciesReducer(state, action) {
    if (state === void 0) { state = {
        currencies: immutable_1.Map(),
        rates: immutable_1.Map(),
        error: undefined,
    }; }
    switch (action.type) {
        case skynet_store_currencies_api_1.currencyStoreManager.actionType(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS):
            var items_1 = action.items;
            if (items_1 === undefined) {
                return state;
            }
            return __assign({}, state, { currencies: state.currencies.withMutations(function (mutable) {
                    items_1.forEach(function (value) { return mutable.set(value.id, value); });
                }) });
        case skynet_store_currencies_api_1.currencyRateStoreManager.actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ONE_SUCCESS):
            var item_1 = action.item;
            if (item_1 === undefined) {
                return state;
            }
            return __assign({}, state, { rates: state.rates.withMutations(function (mutable) {
                    return mutable.set(skynet_store_currencies_api_1.keyExtractor(item_1), item_1);
                }) });
        case skynet_store_currencies_api_1.currencyStoreManager.actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
        case skynet_store_currencies_api_1.currencyRateStoreManager.actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
            return __assign({}, state, { error: action.error });
        default:
            return state;
    }
}
exports.currenciesReducer = currenciesReducer;
//# sourceMappingURL=currency.reducers.js.map